var aoCarousel = require('./experience/aoCarousel');
var processInclude = require('base/util');

$(document).ready(function() {
    processInclude(aoCarousel);
});
